import * as React from "react";
function SvgFavoriteFilled(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M11.419 4.26a.64.64 0 011.162 0l2.089 4.528 4.952.588a.64.64 0 01.36 1.105l-3.662 3.386.972 4.891a.64.64 0 01-.94.683L12 17.006 7.648 19.44a.64.64 0 01-.94-.683l.972-4.891-3.661-3.386a.64.64 0 01.359-1.105l4.952-.588L11.42 4.26z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFavoriteFilled);
export default ForwardRef;
